import { render, staticRenderFns } from "./gjjys.vue?vue&type=template&id=67ae9a9f&scoped=true&"
var script = {}
import style0 from "./gjjys.vue?vue&type=style&index=0&id=67ae9a9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae9a9f",
  null
  
)

export default component.exports